
import { Component, Vue, Watch } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { DeviceType, AppModule } from "@/store/modules/app";
import Hamburger from "@/components/Hamburger/index.vue";
import { companyList, quitCompany } from "@/api/company";
import { getUserToken, setLocUserToken, setUserToken } from "@/utils/cookies";
import { logout, swishCompany, getUserInfo, getStateList, setUserState } from "@/api/users";
import codeApp from "@/assets/images/code-app.png";
import codeWeixin from "@/assets/images/code-weixin.png";
import codeApplet from "@/assets/images/code-applet.jpg";

import html2canvas from "html2canvas";
import {
  getMessageList,
  getNoticeList,
  readMessage,
  readNotice,
} from "@/api/system";
import { formatTime } from "@/utils/index";
import { WorkbenchLayoutModule } from "@/store/modules/workBench";

var QRCode = require("qrcode");

@Component({
  name: "Navbar",
  components: {
    Hamburger,
  },
  filters: {
    formatDate(val: string) {
      const t = new Date(parseInt(val));
      return formatTime(parseInt(val), "{y}-{m}-{d}");
    },
    formatType(val: string) {
      if (val === "5") {
        return "通知";
      } else {
        return "公告";
      }
    },
  },
})
export default class extends Vue {
  private switchCompanyVisible = false;
  private activeMessage = "first";
  private message = [];
  private notice = [];
  private msgCount = 0;
  private noticeCount = 0;
  private qrCode = "";
  private companyList: any = [];
  private codeApp: any = codeApp;
  private codeWeixin: any = codeWeixin;
  private codeApplet: any = codeApplet;

  private isUser: boolean =
    !UserModule.getCompanyId || UserModule.getCompanyId === "0";

  private defaultImgUrl =
    'this.src="' + require("@/assets/images/default-avatar.png") + '"';

  get userInfo() {
    // TODO::获取用户信息
    return UserModule.user;
  }
  get companyInfo() {
    return UserModule.getCompany;
  }
  get count() {
    return this.msgCount + this.noticeCount;
  }
  private env: any = "";
  created() {
    this.msgCount = 0;
    this.noticeCount = 0;
    this.companyQR();
    this.getMessageList();
    this.getNoticeList();
    this.env = process.env.VUE_APP_TIM;
  }

  getMessageList() {
    const params = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : "0",
      user_id: UserModule.getUserId,
      is_read: 0,
      page: 1,
      size: 5,
    };
    getMessageList(params)
      .then((res) => {
        if (res && res.data) {
          this.message = res.data.list;
          this.msgCount = res.data.count;
        }
      })
      .catch((err) => {
        let msg = err.msg;
      });
  }
  getNoticeList() {
    const params = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : "0",
      user_id: UserModule.getUserId,
      is_read: 0,
      page: 1,
      size: 5,
    };
    getNoticeList(params)
      .then((res) => {
        if (res && res.data) {
          this.notice = res.data.list;
          this.noticeCount = res.data.count;
        }
      })
      .catch((err) => {
        let msg = err.msg;
      });
  }
  companyQR() {
    let Qrurl = "";
    if (UserModule.getCompany && (UserModule.getCompany as any).qr_url) {
      Qrurl = (UserModule.getCompany as any).qr_url;
    } else {
      Qrurl = (UserModule.getUserInfo as any).top_qr_code;
    }
    QRCode.toDataURL(Qrurl)
      .then((url: any) => {
        this.qrCode = url;
      })
      .catch((err: any) => {
        let msg = err.msg;
      });
  }
  // 下载二维码
  handleDownload() {
    let code: any = document.querySelector("#qrCodeid");
    let filename =
      this.companyInfo && this.companyInfo.short_name
        ? this.companyInfo.short_name
        : this.companyInfo && this.companyInfo.name
          ? this.companyInfo.name
          : this.userInfo.name;
    code.style.width = "340px";
    code.style.height = "370px";
    code.style.fontSize = "25px";
    html2canvas(code as any).then(function(canvas: any) {
      let image = new Image();
      image.src = canvas.toDataURL("image/png");
      let a = document.createElement("a");
      a.appendChild(image);
      a.href = image.src;
      a.download = filename;
      a.click();
    });
    code.style.width = "100%";
    code.style.height = "auto";
    code.style.fontSize = "14px";
  }

  // 下载图片
  downladImg(val: any) {
    var a = document.createElement("a");
    a.download = "pic";
    // 设置图片地址
    a.href = val;
    a.click();
  }
  // 状态
  private stateList:any=[]
  private switchState(val:any) {
    let pamars:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      state_id: val.id
    }
    setUserState(pamars).then((res:any) => {
      this.showSecussMsg(res.msg);
      getUserInfo({ user_id: UserModule.getUserId, company_id: UserModule.getCompanyId }).then(async res => {
        await UserModule.setLogin(res.data);
      });
    }).catch(err => {
      this.showErrorMsg(err.msg)
    })
  }
  private visibleChange(visible:boolean) {
    if (visible) {
      this.getStateList()
    }
  }
  private getStateList() {
    let pamars:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: 1,
      size: 9999,
    }
    getStateList(pamars).then((res:any) => {
      if (res.data) {
        this.stateList = res.data.list
      } else {
        this.stateList = []
      }
    })
  }
  // get companyList() {
  //   return UserModule.getCompanyList;
  // }
  private switchCompany() {
    this.getCompanyList();
    this.switchCompanyVisible = true;
  }
  doSwitchCompany(companyId: string) {
    let _this = this;
    this.$confirm("是否切换主单位?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async() => {
        if (companyId) {
          _this.switchCompanyData(companyId);
        } else {
          let token: any = getUserToken();
          if (typeof token !== "object") {
            token = JSON.parse(token as string);
          }
          token.company_id = "0";
          setUserToken(JSON.stringify(token));
          setLocUserToken('')
          UserModule.setMainComapy("");
          WorkbenchLayoutModule.setLayout([]);
          _this.$router.push({
            path: "/order/underway?t=" + Date.now(),
          });
          await setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
        this.isUser =
          !UserModule.getCompanyId || UserModule.getCompanyId === "0";
      })
      .catch(() => {});
  }
  private getCompanyList() {
    let parameters: any = {};
    parameters.user_id = UserModule.getUserId;
    parameters.need_auth = "1";
    companyList(parameters)
      .then((res) => {
        if (res.data) {
          this.companyList = res.data.list.reverse();
        }
      })
      .catch((error) => {
        let msg = error.msg;
      });
  }

  private switchCompanyData(companyId: string) {
    let that = this
    let pamars: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      change_company_id: companyId,
      need_auth: 1,
    };
    swishCompany(pamars)
      .then(async(res: any) => {
        let token: any = getUserToken();
        this.showSecussMsg("操作成功");
        if (typeof token !== "object") {
          token = JSON.parse(token as string);
        }
        token.company_id = companyId;
        await setUserToken(JSON.stringify(token));
        await WorkbenchLayoutModule.setLayout([]);
        this.$router.push({
          path: "/index?t=" + Date.now(),
        }).catch(err => {
          let msg = err
        })
        await setTimeout(() => {
          window.parent.location.reload();
        }, 1000);
        this.isUser =
          !UserModule.getCompanyId || UserModule.getCompanyId === "0";
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 退出公司
  private outCompany(row: any) {
    this.$confirm("是否退出公司?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this.quitCompany(row);
      })
      .catch(() => {});
  }
  private quitCompany(row: any) {
    let _this = this;
    let pamars: any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    pamars.quit_company_id = row.id;
    pamars.account_id = UserModule.getAccountId;
    quitCompany(pamars)
      .then(async(res) => {
        if (this.companyList && this.companyList.length === 1) {
          let token: any = getUserToken();
          if (typeof token !== "object") {
            token = JSON.parse(token as string);
          }
          token.company_id = "0";
          setUserToken(JSON.stringify(token));
          await UserModule.setMainComapy("");
          await WorkbenchLayoutModule.setLayout([]);
          _this.$router.push({
            path: "/index?t=" + Date.now(),
          }).catch(err => {
            let msg = err
          })
          await setTimeout(() => {
            window.parent.location.reload();
          }, 1000);
        } else {
          window.location.reload();
        }
        this.isUser =
          !UserModule.getCompanyId || UserModule.getCompanyId === "0";
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private logout() {
    let parmas: any = {};
    parmas.account_id = UserModule.getAccountId;
    logout(parmas)
      .then(async(res) => {
        this.showSecussMsg("退出成功");
        //腾讯tim停用 20251231
        // (this as any).TIM.logout();
        // (this as any).TIM.destroy();
        try {
          (this as any).NIM.V2NIMLoginService.logout()
        } catch (err) {
          // TODO failed, check code
          // console.log(err.code)
        }
        await WorkbenchLayoutModule.setLayout([]);
        await UserModule.ResetToken();
        window.location.href =
          location.protocol + process.env.VUE_APP_LOGIN_URL;
      })
      .catch((err) => {
        this.showSecussMsg(err.msg);
      });
  }

  get device() {
    return AppModule.device;
  }

  get sidebar() {
    return AppModule.sidebar;
  }

  get classObj() {
    return {
      mobile: this.device === DeviceType.Mobile,
    };
  }

  // toggleSideBar() {
  //   AppModule.ToggleSideBar(false);
  // }

  selectMsg(val: any) {
    if (val.msg_type === "5") {
      this.$alert(val.msg_content, "通知", {
        showConfirmButton: false,
        callback: (action) => {
          const params = {
            user_id: UserModule.getUserId,
            company_id: UserModule.getCompanyId ? UserModule.getCompanyId : "0",
            id: val.id,
          };
          readMessage(params)
            .then((res) => {
              this.msgCount = 0;
              this.getMessageList();
            })
            .catch((err) => {
              let msg = err.msg;
            });
        },
      });
    } else {
      const h = this.$createElement;
      this.$msgbox({
        title: "公告",
        message: h("div", undefined, [
          h("h3", undefined, val.notice_title),
          h("p", { style: "color: #999" }, [
            h("span", undefined, val.notice_author),
            h(
              "span",
              { style: "margin-left: 15px" },
              formatTime(parseInt(val.addtime), "{y}-{m}-{d} {h}:{i}")
            ),
          ]),
          h("p", {
            domProps: {
              innerHTML: val.notice_content,
            },
          }),
        ]),
        showConfirmButton: false,
        callback: (action) => {
          const params = {
            user_id: UserModule.getUserId,
            company_notice_id: val.id,
          };
          readNotice(params)
            .then((res) => {
              this.noticeCount = 0;
              this.getNoticeList();
            })
            .catch((err) => {
              let msg = err.msg;
            });
        },
      }).then((action) => {
        this.$message({
          type: "info",
          message: "action: " + action,
        });
      });
    }
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "success",
    });
  }
}
